import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';

/* eslint-disable */
import gbLabels from '../data/language-en.json';
import usLabels from '../data/language-en_US.json';
/* eslint-enable */

const defaultLocale = 'en-gb';

const toLocaleData = (locale) => {
  const labels = {
    'en-us': usLabels,
    'en-gb': gbLabels,
  };
  const validLocale = labels[locale] ? locale : defaultLocale;
  return {
    locale,
    messages: labels[validLocale],
  };
};

const mapStateToProps = (state) => {
  const selectedStoreCode = state.config.selectedLocale || defaultLocale;
  return toLocaleData(selectedStoreCode);
};

export default connect(mapStateToProps)(IntlProvider);
